(() => {
  const formControls = (container) => {
    const controls = [];
    if (container.matches?.("input, select, textarea, button")) controls.push(container);
    controls.push(...container.querySelectorAll("input, select, textarea, button"));
    return controls;
  };

  const createSubmissionGuard = (container) => {
    const state = { blocked: true };
    const syncControls = () => {
      formControls(container).forEach((control) => {
        if (state.blocked) {
          if (!control.disabled) {
            control.dataset.routingDisabled = "true";
            control.disabled = true;
          }
        } else if (control.dataset.routingDisabled === "true") {
          control.disabled = false;
          delete control.dataset.routingDisabled;
        }
      });
    };

    container.addEventListener("submit", (event) => {
      if (!state.blocked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    const observer = new MutationObserver(syncControls);
    observer.observe(container, { childList: true, subtree: true });

    state.setBlocked = (blocked) => {
      state.blocked = blocked;
      container.dataset.routingSubmissionBlocked = String(blocked);
      syncControls();
    };
    state.setBlocked(true);
    return state;
  };

  const initializeAgeRouter = (router) => {
    if (router.dataset.ageRouterReady === "true") return;

    const checkbox = router.querySelector("[data-under-18-toggle]");
    const destination = router.querySelector("[data-under-18-destination]");
    const adultCopy = router.querySelector("[data-adult-route-copy]");
    const section = router.closest("[data-shopify-form-purpose='adult-athlete-application']");
    const adultForm = section?.querySelector("[data-adult-form-container]");
    if (!checkbox || !destination || !adultForm) return;
    const adultSubmissionGuard = createSubmissionGuard(adultForm);

    const render = () => {
      const isMinor = checkbox.checked;
      destination.hidden = !isMinor;
      adultForm.hidden = isMinor;
      adultForm.toggleAttribute("inert", isMinor);
      adultSubmissionGuard.setBlocked(isMinor);
      if (adultCopy) adultCopy.hidden = isMinor;
      checkbox.setAttribute("aria-expanded", String(isMinor));
    };

    checkbox.addEventListener("change", render);
    router.dataset.ageRouterReady = "true";
    render();
  };

  const initializeGuardianAgeGate = (gate) => {
    if (gate.dataset.guardianAgeGateReady === "true") return;

    const input = gate.querySelector("[data-guardian-age-input]");
    const section = gate.closest("[data-shopify-form-purpose='guardian-athlete-application']");
    const guardianForm = section?.querySelector("[data-guardian-form-container]");
    const help = gate.querySelector("[data-guardian-age-help]");
    const under13 = gate.querySelector("[data-guardian-under-13]");
    const adultRoute = gate.querySelector("[data-guardian-adult-route]");
    const eligibleCopy = gate.querySelector("[data-guardian-eligible]");
    if (!input || !guardianForm || !under13 || !adultRoute || !eligibleCopy) return;
    const guardianSubmissionGuard = createSubmissionGuard(guardianForm);

    const render = () => {
      const rawAge = input.value.trim();
      const age = Number(rawAge);
      const isWholeAge = rawAge !== "" && Number.isInteger(age) && age >= 0;
      const isUnder13 = isWholeAge && age < 13;
      const isGuardianEligible = isWholeAge && age >= 13 && age < 18;
      const isAdult = isWholeAge && age >= 18;
      const showForm = gate.dataset.designMode === "true" || isGuardianEligible;

      guardianForm.hidden = !showForm;
      guardianForm.toggleAttribute("inert", !showForm);
      guardianSubmissionGuard.setBlocked(!isGuardianEligible);
      under13.hidden = !isUnder13;
      adultRoute.hidden = !isAdult;
      eligibleCopy.hidden = !isGuardianEligible;
      if (help) help.hidden = isWholeAge;
      input.setAttribute("aria-expanded", String(showForm));
    };

    input.addEventListener("input", render);
    input.addEventListener("change", render);
    gate.dataset.guardianAgeGateReady = "true";
    render();
  };

  const initialize = (root = document) => {
    root.querySelectorAll("[data-athlete-age-route]").forEach(initializeAgeRouter);
    root.querySelectorAll("[data-guardian-age-route]").forEach(initializeGuardianAgeGate);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();
